import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import "antd/dist/antd.less";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initFirebase } from "./Services/firebase";
import history from "./Utils/history";

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById("root")
);

initFirebase();
reportWebVitals();
